/* Split Editorial mega panel (2026-09-24, Claude) - design N8.
   Hovering or focusing a row on the left swaps the photo on the right.
   Delegated, so it survives the theme editor re-rendering a section, and it
   touches nothing outside a [data-gl-split] panel. Roll back by removing the
   script tag in snippets/site-menu.liquid; the panel still renders, it just
   keeps showing the first photo. */
(function () {
  'use strict';
  if (window.__glSplitReady) return;
  window.__glSplitReady = true;

  function show(panel, i) {
    var rows = panel.querySelectorAll('[data-gl-split-row]');
    var phs = panel.querySelectorAll('[data-gl-split-ph]');
    var n;
    for (n = 0; n < rows.length; n++) {
      rows[n].classList.toggle('is-on', rows[n].getAttribute('data-gl-split-row') === i);
    }
    for (n = 0; n < phs.length; n++) {
      phs[n].classList.toggle('is-on', phs[n].getAttribute('data-gl-split-ph') === i);
    }
  }

  function promote(panel) {
    if (panel.__glSplitLoaded) return;
    panel.__glSplitLoaded = true;
    var imgs = panel.querySelectorAll('[data-gl-split-ph][data-gl-src]');
    for (var n = 0; n < imgs.length; n++) {
      var img = imgs[n];
      if (img.getAttribute('data-gl-srcset')) img.setAttribute('srcset', img.getAttribute('data-gl-srcset'));
      img.setAttribute('src', img.getAttribute('data-gl-src'));
      img.removeAttribute('data-gl-src');
      img.removeAttribute('data-gl-srcset');
    }
    // 2026-10-10 (Claude) - Joel: "images in the dropdown menu load slow". loading="lazy" inside a
    // closed (hidden) panel held the photos back until the panel was already on screen, so each
    // hover started a fresh download. Eager + decode here means the photo is ready when shown.
    var all = panel.querySelectorAll('[data-gl-split-ph]');
    for (var k = 0; k < all.length; k++) {
      all[k].loading = 'eager';
      if (all[k].decode && all[k].getAttribute('src')) all[k].decode().catch(function () {});
    }
  }

  // 2026-10-10 (Claude) - WARM THE MENU AFTER THE PAGE HAS LOADED, desktop mouse users only. Once the
  // page is idle, each panel's photos are fetched one panel at a time at low priority, so the first
  // hover finds them in cache instead of waiting 0.5-2.8s per photo (measured on live 2026-10-10).
  // Phones, touch screens and Save-Data never pay for it. Roll back: delete this block.
  function warm() {
    var mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
    if (!mq || !mq.matches) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    var panels = document.querySelectorAll('[data-gl-split]');
    var i = 0;
    (function next() {
      if (i >= panels.length) return;
      var p = panels[i++];
      var imgs = p.querySelectorAll('[data-gl-split-ph][data-gl-src]');
      for (var n = 0; n < imgs.length; n++) imgs[n].fetchPriority = 'low';
      promote(p);
      setTimeout(next, 600);
    })();
  }
  function warmLater() {
    setTimeout(function () {
      if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 4000 });
      else warm();
    }, 2500);
  }
  if (document.readyState === 'complete') warmLater();
  else window.addEventListener('load', warmLater, { once: true });

  function opened(e) {
    var panel = e.target && e.target.closest ? e.target.closest('[data-gl-split]') : null;
    if (!panel) {
      var li = e.target && e.target.closest ? e.target.closest('li.gl-has-mega') : null;
      panel = li ? li.querySelector('[data-gl-split]') : null;
    }
    if (panel) promote(panel);
  }

  function from(e) {
    var row = e.target && e.target.closest ? e.target.closest('[data-gl-split-row]') : null;
    if (!row) return;
    var panel = row.closest('[data-gl-split]');
    if (!panel) return;
    show(panel, row.getAttribute('data-gl-split-row'));
  }

  function home(e) {
    var panel = e.target && e.target.closest ? e.target.closest('[data-gl-split]') : null;
    if (!panel) return;
    if (e.relatedTarget && panel.contains(e.relatedTarget)) return;
    if (!panel.querySelector('[data-gl-split-home]')) return;
    show(panel, 'rail');
  }

  document.addEventListener('mouseleave', home, true);
  document.addEventListener('mouseover', from, true);
  document.addEventListener('focusin', from, true);
  document.addEventListener('mouseover', opened, true);
  document.addEventListener('focusin', opened, true);

  // 2026-10-07 (Claude) - the photo is a button: a click anywhere on it that is not already on a link
  // opens the lit row, else the panel's own CTA. Ctrl/Cmd/middle click open a new tab. CSS in gl-split.css.
  function go(e) {
    var right = e.target && e.target.closest ? e.target.closest('.gl-split__right') : null;
    if (!right || e.target.closest('a')) return;
    if (e.type === 'auxclick' && e.button !== 1) return;
    var panel = right.closest('[data-gl-split]');
    if (!panel) return;
    var a = panel.querySelector('.gl-split__row.is-on') || panel.querySelector('.gl-split__cta') || panel.querySelector('.gl-split__row');
    if (!a || !a.href) return;
    if (e.ctrlKey || e.metaKey || e.button === 1) window.open(a.href, '_blank');
    else window.location.href = a.href;
  }
  document.addEventListener('click', go, true);
  document.addEventListener('auxclick', go, true);
})();
